import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Svg from "react-native-svg";
import CryptoJS from "crypto-js";
import {
  getWorkflowAPI,
  putReviewflowAPI,
  putWorkflowAPI,
} from "../../api/apis/workflow";
import { Redirect } from "react-router-dom";
import { getAllReviewsAPI } from "../../api/apis/event";
import {
  Box,
  HStack,
  Pressable,
  Spinner,
  Text,
  VStack,
  useMediaQuery,
} from "native-base";
import MobileHeader from "../../layout/header/mobileHeader";
import Breadcrumbs from "../../components/breadcrumb";
import WebHeader from "../../layout/header/webHeader";
import { COLORS } from "../../utils/colors";
import { Toaster } from "../../components/toaster";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import Reviews from "../../containers/review";
import DividerLine from "../../components/divider";
import ContainerCards from "../../components/cards";
import Comments from "../../containers/comments";
import { hasPermission } from "../../utils/permission";
import { COMMONFONTSIZE } from "../../utils/fonts";
import CustomButton from "../../components/button";
import { reviewTickSVG, reviewUnTickSVG } from "../../utils/svg";
import { getNotificationAPI } from "../../api/apis/notification";
import { useSelector } from "react-redux";
import config from "../../utils/config";

const ReviewApprovalPage = () => {
  const toaster = Toaster();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [workflow, setWorkflow] = useState({});
  const eventBytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("event"),
    config.eventKey
  );
  const eventString = eventBytes.toString(CryptoJS.enc.Utf8);
  const selectedEvent = JSON.parse(eventString);
  const [selectedImageIndex, setSelectedImageIndex] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [totalReviewCount, setTotalReviewCount] = useState(0);
  const [totalRated, setTotalRated] = useState(0);
  const [permission, setPermission] = useState(false);
  const [totalReview, setTotalReview] = useState([0, 0, 0, 0, 0]);
  const eventTab = selectedEvent.type === "event" ? "Event" : "MICE";
  const breadcrumbDetails = {
    activeTab: { name: "Home", path: "/home" },
    activeMenu: { name: `${eventTab} Details`, path: "/event-detail" },
    activeActivePage: {
      name: "Reviews",
      path: location.pathname,
    },
  };
  const [pending, setPending] = useState(0);
  const [pendingData, setPendingData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AddWorkflow();
    if (location.pathname === "/event-detail/new-review-detail") {
      setPermission(true);
    }
  }, [location]);

  useEffect(() => {
    if (reviews) {
      let rating = 0;
      let count = 0;
      let total = [0, 0, 0, 0, 0];
      let pendingData = [];
      reviews.map((review) => {
        if (review.status === "pending") {
          setPending((prev) => prev + 1);
          pendingData.push(review);
        }
        if (
          review.status !== "pending" &&
          review.status !== "review_rejected"
        ) {
          count = count + 1;
          rating = rating + parseFloat(review.rating);
          total[Math.floor(review.rating) - 1] =
            total[Math.floor(review.rating) - 1] + 1;
        }
      });
      let average = rating / count;
      average = parseFloat(average.toFixed(1));
      if (average > 5) {
        average = 5;
      }
      if (average) setTotalReviewCount(average);
      setTotalRated(count);
      setTotalReview(total);
      setPendingData(pendingData);

      if (
        reviews.length > 0 &&
        pendingData.length === 0 &&
        location.pathname === "/event-detail/new-review-detail"
      )
        setShouldRedirect(true);
    }
  }, [reviews]);

  const AddWorkflow = async () => {
    let res = await getWorkflowAPI();
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let workflows = {};
      res.data.data.data?.map((item) => {
        if (item.name === "ReviewWorkflow") {
          workflows["review"] = item;
        }
      });
      setWorkflow(workflows);
      if (
        workflows &&
        workflows["review"] &&
        workflows["review"]["_id"] &&
        selectedEvent &&
        selectedEvent._id
      )
        getReviews(workflows["review"]["_id"], selectedEvent._id);
    }
  };

  const getReviews = async (
    workflow_id = workflow["review"]["_id"],
    event_id = selectedEvent._id
  ) => {
    setIsLoading(true);
    let res = await getAllReviewsAPI(workflow_id, event_id);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      setReviews(
        res?.data?.data?.data
          .filter((review) => review.added_by === userInfo.user_id)
          .concat(
            res?.data?.data?.data.filter(
              (review) => review.added_by !== userInfo.user_id
            )
          )
      );
      // setReviews(res?.data?.data?.data);
    }
    setIsLoading(false);
  };

  const handleSelectedImages = (index) => {
    let selectInd = [];
    if (index === "select_all") {
      if (selectedImageIndex.length === pendingData.length) selectInd = [];
      else selectInd = pendingData.map((_, i) => i);
    } else {
      if (selectedImageIndex.length > 0 && selectedImageIndex.includes(index))
        selectInd = selectedImageIndex.filter((image) => image !== index);
      else selectInd = [...selectedImageIndex, index];
    }
    setSelectedImageIndex(selectInd);
  };

  const getPermission = (item) => {
    if (
      hasPermission("REVIEW_LIST") &&
      permission &&
      item.status === "pending"
    ) {
      return true;
    }
    if (
      hasPermission("REVIEW_LIST") &&
      !permission &&
      item.status !== "review_rejected"
    ) {
      return true;
    }
    if (
      !hasPermission("REVIEW_LIST") &&
      !permission &&
      (item.status === "review_approved" ||
        (item.status === "pending" && userInfo.user_id === item.added_by))
    ) {
      return true;
    }
    return false;
  };

  if (shouldRedirect) {
    return <Redirect to="/event-detail" />;
  }

  const approveReviewWorkflow = async (
    reviewPayload,
    step,
    id,
    action_name
  ) => {
    let res = await putReviewflowAPI(
      reviewPayload,
      workflow["review"]["_id"],
      step,
      id,
      action_name
    );
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      toaster("Updated Successfully", "success", "success");
      await getReviews();
    }
    setSelectedImageIndex([]);
    setPendingData([]);
  };

  return (
    <>
      <Box bg={COLORS.THEME_BACKGROUND}>
        <Box bg={COLORS.WHITE_COLOR}>
          {MobileWindow ? (
            <MobileHeader showTabs={false} />
          ) : (
            <>
              <WebHeader showTabs={false} />
              <Box p={4} px={"5rem"}>
                <Breadcrumbs path={breadcrumbDetails} />
              </Box>
            </>
          )}
        </Box>
      </Box>

      <VStack
        pl={!MobileWindow && 20}
        pr={!MobileWindow && 20}
        bg={COLORS.WHITE_COLOR}
        space={3}
        borderRadius={"8px"}
        w={"100%"}
      >
        {!permission && (
          <Box py={4} pl={4} width={"100%"}>
            <Box mr={"9.5rem"} width={MobileWindow && "100%"}>
              <Reviews
                overallAverage={totalReviewCount}
                overallRating={totalRated}
                totalReview={totalReview}
                progressBarWidth="30%"
              />
            </Box>
          </Box>
        )}
        {isLoading ? (
          <Box mt={10} flex={1} alignItems="center" justifyContent="center">
            <Spinner color={COLORS.THEME_COLOR} size="lg" />
          </Box>
        ) : (
          reviews.length > 0 && (
            <>
              <DividerLine direction="horizontal" />

              <Box ml={4}>
                {hasPermission("REVIEW") && permission && (
                  <HStack>
                    <Pressable
                      onPress={() => {
                        handleSelectedImages("select_all");
                      }}
                      style={{
                        width: "30px",
                        height: "60px",
                        paddingTop: "15px",
                      }}
                    >
                      <Svg
                        width={MobileWindow ? 156 : 280}
                        height={MobileWindow ? 156 : 280}
                        viewBox={`0 0 "47" "47"`}
                      >
                        {selectedImageIndex.length === pendingData.length
                          ? reviewTickSVG
                          : reviewUnTickSVG}
                      </Svg>
                    </Pressable>
                    <Text mt={4}>Select All</Text>
                  </HStack>
                )}
              </Box>
              <VStack alignItems={"center"} px={4} space={2} mb={"100px"}>
                {permission
                  ? pendingData.map((item, index) => {
                      if (
                        (!hasPermission("REVIEW") && getPermission(item)) ||
                        (hasPermission("REVIEW") &&
                          getPermission(item) &&
                          (window.location.pathname ===
                          "/event-detail/new-review-detail"
                            ? item.status === "pending"
                            : item.status !== "review_rejected"))
                      ) {
                        return (
                          <HStack w="100%">
                            {hasPermission("REVIEW") && permission && (
                              <Pressable
                                onPress={() => {
                                  handleSelectedImages(index);
                                }}
                                style={{
                                  width: "30px",
                                  height: "60px",
                                  paddingTop: "15px",
                                }}
                              >
                                <Svg
                                  width={MobileWindow ? 156 : 280}
                                  height={MobileWindow ? 156 : 280}
                                  viewBox={`0 0 "47" "47"`}
                                >
                                  {selectedImageIndex.length > 0 &&
                                  selectedImageIndex.includes(index)
                                    ? reviewTickSVG
                                    : reviewUnTickSVG}
                                </Svg>
                              </Pressable>
                            )}
                            <ContainerCards
                              background={COLORS.ATTACHMENT_FILES_COLOR}
                              width="100%"
                              height="auto"
                              boxShadow="none"
                            >
                              <Comments
                                getReviews={getReviews}
                                reviewPayload={item}
                                stars={item.rating}
                                comments={item.review}
                                approveReviewWorkflow={approveReviewWorkflow}
                                approval={true}
                                readAll={true}
                              />
                            </ContainerCards>
                          </HStack>
                        );
                      }
                    })
                  : reviews.map((item, index) => {
                      if (
                        (!hasPermission("REVIEW") && getPermission(item)) ||
                        (hasPermission("REVIEW") &&
                          getPermission(item) &&
                          (window.location.pathname ===
                          "/event-detail/new-review-detail"
                            ? item.status === "pending"
                            : item.status !== "review_rejected"))
                      ) {
                        return (
                          <HStack w="100%">
                            {hasPermission("REVIEW") && permission && (
                              <Pressable
                                onPress={() => {
                                  handleSelectedImages(index);
                                }}
                                style={{
                                  width: "30px",
                                  height: "60px",
                                  paddingTop: "15px",
                                }}
                              >
                                <Svg
                                  width={MobileWindow ? 156 : 280}
                                  height={MobileWindow ? 156 : 280}
                                  viewBox={`0 0 "47" "47"`}
                                >
                                  {selectedImageIndex.length > 0 &&
                                  selectedImageIndex.includes(index)
                                    ? reviewTickSVG
                                    : reviewUnTickSVG}
                                </Svg>
                              </Pressable>
                            )}
                            <ContainerCards
                              background={COLORS.ATTACHMENT_FILES_COLOR}
                              width="100%"
                              height="auto"
                              boxShadow="none"
                            >
                              <Comments
                                getReviews={getReviews}
                                reviewPayload={item}
                                stars={item.rating}
                                comments={item.review}
                                approveReviewWorkflow={approveReviewWorkflow}
                                approval={true}
                                readAll={true}
                              />
                            </ContainerCards>
                          </HStack>
                        );
                      }
                    })}
              </VStack>
            </>
          )
        )}
      </VStack>

      {hasPermission("REVIEW") && permission && (
        <HStack
          alignItems={"center"}
          bg={COLORS.WHITE_COLOR}
          w={"100%"}
          py={4}
          justifyContent={MobileWindow ? "center" : "flex-end"}
          space={MobileWindow ? 2 : 5}
          pr={MobileWindow ? 3 : 10}
          position={"fixed"}
          bottom={0}
        >
          {selectedImageIndex && selectedImageIndex.length === 0 && (
            <CustomButton
              onPress={() => {
                let payload = [];
                let id = [];
                reviews &&
                  reviews.length > 0 &&
                  reviews.map((item) => {
                    if (item.status === "pending") {
                      let data = item;
                      id = [...id, data["_id"]];
                      data["workflow_instance_id"] = data["_id"];
                      delete data["_id"];
                      data.approved_at = new Date();
                      data.approved_by = userInfo.user_id;
                      payload.push(data);
                    }
                    //     let data = reviews[item];
                    //     id = [data["_id"]];
                    //     data["workflow_instance_id"] = data["_id"];
                    //     delete data["_id"];
                    //     data.approved_at = new Date();
                    //     data.approved_by = userInfo.user_id;
                    //     payload.push(data);
                    //   });
                    // approveReviewWorkflow(
                    //   payload,
                    //   "REVIEW_APPROVAL",
                    //   id,
                    //   "REJECT_REVIEWS"
                    // );
                    // }}
                  });
                approveReviewWorkflow(
                  payload,
                  "REVIEW_APPROVAL",
                  id,
                  "REJECT_REVIEWS"
                );
              }}
              text="Reject All"
              textColor={COLORS.REJECT_TEXT_COLOR}
              isOutline
              bgColor={COLORS.REJECT_TEXT_COLOR}
              fontSize={
                MobileWindow
                  ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                  : COMMONFONTSIZE.LARGE_FONT_SIZE
              }
            />
          )}
          <CustomButton
            onPress={() => {
              if (selectedImageIndex && selectedImageIndex.length === 0)
                toaster("Please select any review", "error", "error");
              else if (selectedImageIndex.length > 0) {
                let payload = [],
                  id;
                selectedImageIndex &&
                  selectedImageIndex.length > 0 &&
                  selectedImageIndex.map((item) => {
                    let data = pendingData[item];
                    id = data["_id"];
                    data["workflow_instance_id"] = data["_id"];
                    delete data["_id"];
                    data.approved_at = new Date();
                    data.approved_by = userInfo.user_id;
                    payload.push(data);
                  });
                approveReviewWorkflow(
                  payload,
                  "REVIEW_APPROVAL",
                  selectedEvent._id,
                  "APPROVE_REVIEWS"
                );
              }
            }}
            text={`Approve`}
            bgColor={COLORS.THEME_COLOR}
            textColor={COLORS.WHITE_COLOR}
            fontSize={
              MobileWindow
                ? COMMONFONTSIZE.MEDIUM_FONT_SIZE
                : COMMONFONTSIZE.LARGE_FONT_SIZE
            }
          />
        </HStack>
      )}
    </>
  );
};

export default ReviewApprovalPage;
